import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import useAppChoices from '../../../../../hooks/useAppChoices';
import { TASK_ROLES } from '../../../../../helpers/constants';

const AssignedProcessorsMultiSelectModal = ({ show, onHide, onConfirm, prevData, isEditing, title = 'Assigned Processor' }) => {
  const user = useAppChoices('users');
  const processors = user.filter(u => TASK_ROLES.includes(u.role));
  const AssignedProcessors = isEditing ? processors : processors.filter(p => p.isEnabled);

  const enabledProcessors = useMemo(() => AssignedProcessors.filter(p => p.isEnabled), [AssignedProcessors]);

  const [selectedProcessor, setSelectedProcessor] = useState(prevData || []);
  const [saving, setSaving] = useState(false);

  const disabledSelectedProcessors = useMemo(() => {
    const selectedIds = new Set((selectedProcessor || []).map(p => p?._id || p));
    return AssignedProcessors.filter(p => !p.isEnabled && selectedIds.has(p._id));
  }, [AssignedProcessors, selectedProcessor]);

  useEffect(() => {
    setSelectedProcessor(prevData);
  }, [prevData]);
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        if (prevData.length > selectedProcessor.length) {
          setSelectedProcessor(prevData);
        }
      }}
      centered
      contentClassName="scrollable-modal-content"
    >
      <Modal.Header>
        <Modal.Title>
          <h6 className="mb-0">{title}</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto px-2">
        <h6 className="smallFont">Active Users</h6>
        {enabledProcessors.map(a => (
          <div key={a._id} className="mt-3">
            <input
              style={{ height: 17, width: 17 }}
              type="checkbox"
              className="form-check-input mt-0 ml-2"
              onChange={() => {
                if (selectedProcessor.find(p => (p?._id || p) === a._id)) {
                  setSelectedProcessor(selectedProcessor.filter(value => a._id !== (value?._id || value)));
                } else {
                  setSelectedProcessor(prevData => [...prevData, a]);
                }
              }}
              checked={!!selectedProcessor.find(value => a._id === (value?._id || value))}
              disabled={saving}
            />
            <p className="ml-5">{a.name}</p>
          </div>
        ))}

        {disabledSelectedProcessors.length > 0 && (
          <>
            <hr />
            <h6 className="smallFont">Inactive Users</h6>
            {disabledSelectedProcessors.map(a => (
              <div key={a._id} className="mt-3">
                <input
                  style={{ height: 17, width: 17 }}
                  type="checkbox"
                  className="form-check-input mt-0 ml-2"
                  onChange={() => {
                    if (selectedProcessor.find(p => (p?._id || p) === a._id)) {
                      setSelectedProcessor(selectedProcessor.filter(value => a._id !== (value?._id || value)));
                    } else {
                      setSelectedProcessor(prevData => [...prevData, a]);
                    }
                  }}
                  checked={selectedProcessor.find(value => a._id === (value?._id || value))}
                  disabled={saving}
                />
                <p className="ml-5">{a.name}</p>
              </div>
            ))}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={async () => {
            setSaving(true);
            try {
              await onConfirm(selectedProcessor);
            } finally {
              setSaving(false);
            }
          }}
          disabled={saving}
          className="d-flex align-items-center justify-content-center"
        >
          {saving && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="mr-2"
            />
          )}
          {saving ? 'Saving...' : 'Okay'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignedProcessorsMultiSelectModal;
